import { MutationTree, ActionTree, GetterTree } from "vuex";
import { RootState } from "@/store";

export class UserState {
  role = "";
  email = "";
  name = "";
}

const mutations: MutationTree<UserState> = {
  setRole(state, role: string) {
    state.role = role;
  },
  setEmail(state, email: string) {
    state.email = email;
  },
  setName(state, name: string) {
    state.name = name;
  },
};

const getters: GetterTree<UserState, RootState> = {
  isAdmin(state): boolean {
    return state.role == "admin";
  },
};

const actions: ActionTree<UserState, RootState> = {
  setRole({ commit }, role: string) {
    commit("setRole", role);
  },
  setEmail({ commit }, email: string) {
    commit("setEmail", email);
  },
  setName({ commit }, name: string) {
    commit("setName", name);
  },
  clearUser({ commit }) {
    commit("setRole", "");
    commit("setEmail", "");
    commit("setName", "");
  },
};

export const user = {
  namespaced: true,
  state: new UserState(),
  mutations,
  actions,
  getters,
};
